import { Box } from "@mui/joy";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Cargando } from "../utils/Cargando";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";

export const Resultado2 = () => {
  const { id } = useParams();
  const [load, setLoad] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      cargar(id);
    }
  }, [id]);

  async function cargar(id) {
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch("https://portal.publimed.net/api/v1/CCompra/" + id, requestOptions)
      .then((response) => response.text())
      .then(async (result) => {
        let res = JSON.parse(result);

        if (res?.dlocalgo) {
          const myHeaders = new Headers();
          myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify({
              payment_id: res?.dlocalgo,
            }),
          };
          await fetch("https://publimed.net/API/dlocalgo.php", requestOptions)
            .then((response) => response.text())
            .then((result) => {
              let res = JSON.parse(result);
              if (
                res?.estado === "EN BOTON DE PAGO" ||
                res === `{"estado" : "En Proceso"}`
              ) {
                Swal.fire({
                  icon: "info",
                  html: "La compra se encuentra en proceso, realice el pago.",
                  willClose: () => {
                    navigate("/");
                  },
                });
              } else if (res?.estado === "APROBADO") {
                Swal.fire({
                  icon: "info",
                  html: "La compra ha sido aprobada",
                  willClose: () => {
                    navigate("/");
                  },
                });
              } else if (res?.estado === "CANCELADO") {
                Swal.fire({
                  icon: "info",
                  html: "La compra ha sido cancelada o ha expirado",
                  willClose: () => {
                    navigate("/");
                  },
                });
              }
            })
            .catch((error) => {
              console.error(error);
              Swal.fire({
                icon: "warning",
                html: "La compra no fue realizada",
              });
              navigate("/");
            });
        } else {
          Swal.fire({
            icon: "warning",
            html: "La compra no es por medio de un botón de pago, no se puede consultar su estado",
          });
          navigate("/");
        }
        setLoad(false);
      })
      .catch((error) => {
        setLoad(false);
        console.error(error);
        Swal.fire({
          icon: "warning",
          html: "La compra no fue realizada",
        });
        navigate("/");
      });
  }
  return (
    <Box>
      <Helmet>
        <title>{"Publimed Store"}</title>
      </Helmet>
      <Cargando open={load} />
    </Box>
  );
};
